
import React, {useState, useEffect} from "react";

import axios from "axios";

import { Link, useNavigate } from 'react-router-dom';

import validator from 'validator';
import Swal from "sweetalert2";
import GoogleLoginAuthButton from "../component/GoogleLoginAuthButton";


axios.defaults.baseURL='https://suvivah.org/suvivah/api/';

function LoginContent() {
    let navigate = useNavigate();

    let [email,setEmail] = useState("");
    let [user,setUser] = useState("");
    let [password,setPassword] = useState("");

    let [emailerr,setEmailerr] = useState(false);
    let [usererr,setUsererr] = useState(false);
    let [passworderr,setPassworderr] = useState(false);

    let [flagmsg,setFlagmsg]=useState(false);
    let [msg,setMsg]=useState("");
    let [msgcode,setMsgcode]=useState("");
    let [msgcolor,setMsgcolor]=useState("");
    let [btnlogin,setBtnlogin]=useState(false);

    async function loginauth() {
        var flag=1;

        const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isPhone = /^\d{10}$/.test(user);
        const isEmail = EMAIL.test(user);

        if (!isPhone && !isEmail) {
            setUsererr(true);
            flag = 0;
        }

        if (password.length<6) {
            setPassworderr(true);
            flag=0;
        }

        if (flag==1) {
            var fd=new FormData();
            // fd.append("email",email);  
            fd.append("user",user);     
            fd.append("password",password);           

            try {
                var resp=await axios.post("/custlogin",fd);
                // var data=resp.data;

                if (resp.data.msgcode==1) {
                    Swal.fire({
                        icon: "success",
                        title: "Login Successful",
                        text: resp.data.msg,
                        confirmButtonColor: "#dc3545",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: true
                    }).then(() => {
                        // Redirect if required
                        localStorage.setItem("pid", resp.data.profileid);
                        navigate("/dashboard");

                    });
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Login Failed",
                        text: resp.data.msg,
                        confirmButtonColor: "#dc3545"
                    });
                }

                

            } catch (err) {

                Swal.fire({
                    icon: "error",
                    title: "Login Failed",
                    text: err.response?.data?.msg || "Something went wrong.",
                    confirmButtonColor: "#dc3545"
                });

            }
        }

    }

    useEffect(()=>{
        if (localStorage.getItem("pid")) {
            let path=`/dashboard`;
            navigate(path);
        }
    },[])

    return(
        <>

<div class="devider"></div>

<section class="login-row">
<div class="container">

    {flagmsg?<div className={msgcolor}>{msg}</div>:''}

    <div className="container py-3">
        <div className="row justify-content-center">
            <div className="col-lg-7 col-md-7">

                <div className="card login-card border-0 shadow-lg rounded-4 overflow-hidden">

                    {/* Header */}
                    <div className="login-header text-center text-white py-2">
                        <i className="bi bi-person-circle display-4"></i>
                        <h3 className="fw-bold mt-2 mb-1 text-light">Sign In to Your Account</h3>
                        <p className="mb-0">Enter your credentials to continue.</p>
                    </div>

                    <div className="card-body p-4">

                        {/* Phone */}
                        <div className="mb-4">
                            <label className="form-label fw-semibold">
                                Registered Mobile No / Email ID
                            </label>

                            <div className="input-group">
                                <span className="input-group-text">
                                    <i className="bi bi-phone"></i>
                                </span>

                                <input
                                    type="text"
                                    className="form-control"
                                    // maxLength={10}
                                    placeholder="Registered Mobile / Email Id"
                                    onChange={(ev) => {
                                        setUser(ev.target.value);
                                        const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                        const isPhone = /^\d{10}$/.test(ev.target.value);
                                        const isEmail = EMAIL.test(ev.target.value);

                                        if (isPhone || isEmail) {
                                            setUsererr(false);
                                        }
                                    }}
                                />
                            </div>

                            {usererr && (
                                <small className="text-danger">
                                    Please enter a valid 10-digit mobile number or email address.
                                </small>
                            )}
                        </div>

                        {/* Password */}
                        <div className="mb-3">
                            <label className="form-label fw-semibold">
                                Password
                            </label>

                            <div className="input-group">
                                <span className="input-group-text">
                                    <i className="bi bi-lock"></i>
                                </span>

                                <input
                                    type="password"
                                    className="form-control"
                                    placeholder="Enter Password"
                                    onChange={(ev) => {
                                        setPassword(ev.target.value);

                                        if (ev.target.value.length >= 6) {
                                            setPassworderr(false);
                                        }
                                    }}
                                />
                            </div>

                            {passworderr && (
                                <small className="text-danger">
                                    Valid Password Required
                                </small>
                            )}
                        </div>

                        {/* Forgot Password */}
                        <div className="text-end mb-4">
                            <Link
                                to="/forgotpassword"
                                className="text-decoration-none fw-semibold text-danger"
                                // onClick={(e) => {
                                //     e.preventDefault();
                                //     navigate('/forgotpassword')
                                // }}
                            >
                                Forgot Password?
                            </Link>
                        </div>

                        {/* Login Button */}
                        <div className="d-flex justify-content-center">
                            <button
                                type="button"
                                className="btn btn-danger btn-lg w-75 rounded-pill fw-bold"
                                onClick={loginauth}
                                disabled={btnlogin}
                            >
                                {btnlogin ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2"></span>
                                        Logging In...
                                    </>
                                ) : (
                                    <>
                                        <i className="bi bi-box-arrow-in-right me-2"></i>
                                        Login
                                    </>
                                )}
                            </button>
                        </div>

                        {/* Google Authentication */}
                        <div className="text-center my-4">

                            <div className="text-muted mb-3 fw-bold">

                                OR

                            </div>

                            <GoogleLoginAuthButton/>

                        </div>
                        {/* Google Authentication */}

                        {/* Register */}
                        <div className="text-center mt-4">
                            <small className="text-muted">
                                Don't have an account?
                                <Link
                                    to="/register"
                                    className="text-danger fw-bold ms-1 text-decoration-none"
                                >
                                    Register Now
                                </Link>
                            </small>
                        </div>

                    </div>

                </div>

            </div>
        </div>
    </div>

    {/* <div class="row">
        <div class="col-md-8 offset-md-2">
                <div class="register_box">
            <div class="row mb-3">               

                <div class="col-md-12">
                    <input type="email" class="form-control" maxLength={10} id="email" placeholder="Enter Registered Phone Number" name="email" onChange={(ev)=>{
                        setPhone(ev.target.value);
                        if (ev.target.value.length==10) {
                            setPhoneerr(false);
                        }
                    }} />
                    {phoneerr?<div className='text text-danger small'>Valid Phone Number Required</div>:''}
                </div>
                
            </div>
            

            <div class="row mb-3">
                <div class="col-md-12">
                     <input type="password" class="form-control" placeholder="Enter Valid Password" name="password" onChange={(ev)=>{
                        setPassword(ev.target.value);
                        if (password.length>5) {
                            setPassworderr(false);
                        }
                     }} />
                     {passworderr?<div className='text text-danger small'>Valid Password Required</div>:''}
                </div>
                            
            </div>

            <div class="row">                
                <div class="col-md-12 text-center">
                   <button type="button" class="btn btn-red px-5 t" onClick={loginauth} disabled={btnlogin}>Login</button>
                </div>               
            </div>

            </div>
            <p class="text-center pt-2"><a href="#" class="text-black" onClick={()=>{
                alert("Coming Soon....");
            }}>Forgot Password?</a></p>
        </div>

    </div> */}
</div>
</section>




        </>
    );
}

export default LoginContent;